(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zhenzhu-gift-samples"]) return;
  try {
    
  if (!customElements.get('zhenzhu-gift-samples')) {
    customElements.define('zhenzhu-gift-samples', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.requiredProducts = [15920179708252, 15920179741020, 15920179839324];
        this.keys = ['Medik8 luxe minisample 1', 'Medik8 luxe minisample 2', 'Cadeauactie'];
        this.config = JSON.parse(this.querySelector('[data-gift-config]').textContent);
        this.root = this.config.root.replace(/\/?$/, '/');
        this.cart = JSON.parse(this.querySelector('[data-gift-cart]').textContent);
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('[data-gift-form]');
        this.selects = [...this.querySelectorAll('select')];
        this.samples = [...this.selects[0].options].map(option => option.value).filter(Boolean);
        this.status = this.querySelector('[data-gift-status]');
        this.pendingCheckout = false;
        this.busy = false;
        document.documentElement.classList.toggle('zh-gift-product', this.requiredProducts.includes(this.config.productId));
        this.querySelector('[data-gift-close]').addEventListener('click', () => this.dialog.close());
        this.selects.forEach(select => select.addEventListener('change', () => this.updateOptions()));
        this.form.addEventListener('submit', event => this.save(event));
        this.onClick = event => {
          const edit = event.target.closest('[data-zh-gift-open]');
          if (edit) { event.preventDefault(); this.open(false); return; }
          const target = event.target.closest('button[name="checkout"], input[name="checkout"], a[href]');
          if (!target || target.closest('zhenzhu-gift-samples')) return;
          if (target.tagName === 'A') {
            const path = new URL(target.href, location.href).pathname;
            if (!/(^|\/)checkout\/?$/.test(path)) return;
          }
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.checkout();
        };
        this.onSubmit = event => {
          if (event.target === this.form) return;
          if (event.submitter?.name !== 'checkout') return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.checkout();
        };
        document.addEventListener('click', this.onClick, true);
        document.addEventListener('submit', this.onSubmit, true);
        this.sync();
        this.observer = new MutationObserver(records => {
          const changed = records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && !node.closest?.('zhenzhu-gift-samples, .zh-gift-banner') && (node.matches?.('cart-items, cart-drawer, #cart-notification, #main-cart-footer, #main-cart-items, .cart-item') || node.querySelector?.('.cart-item, cart-items, #main-cart-footer'))));
          if (changed) this.scheduleRefresh();
        });
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.onChange = event => {
          if (event.target.matches('[name="updates[]"]')) this.scheduleRefresh();
        };
        document.addEventListener('change', this.onChange);
        this.onAdded = event => {
          if (event.target.matches('form[action*="/cart/add"]')) this.scheduleRefresh();
        };
        document.addEventListener('submit', this.onAdded);
        this.onPage = () => this.refresh().catch(() => {});
        window.addEventListener('pageshow', this.onPage);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.scheduleRefresh());
        }
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onClick, true);
        document.removeEventListener('submit', this.onSubmit, true);
        document.removeEventListener('change', this.onChange);
        document.removeEventListener('submit', this.onAdded);
        window.removeEventListener('pageshow', this.onPage);
        this.observer?.disconnect();
        this.unsubscribe?.();
        clearTimeout(this.refreshTimer);
      }
      eligible(cart = this.cart) {
        return this.requiredProducts.every(id => cart.items.some(item => Number(item.product_id) === id && item.quantity > 0));
      }
      chosen(cart = this.cart) {
        const a = cart.attributes?.[this.keys[0]] || '';
        const b = cart.attributes?.[this.keys[1]] || '';
        return this.samples.includes(a) && this.samples.includes(b) && a !== b ? [a, b] : [];
      }
      async request(path, body) {
        const response = await fetch(this.root + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : { cache: 'no-store' });
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      }
      async refresh() {
        this.cart = await this.request('cart.js');
        this.sync();
        return this.cart;
      }
      scheduleRefresh() {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => this.refresh().catch(() => {}), 700);
      }
      sync() {
        const eligible = this.eligible();
        document.documentElement.classList.toggle('zh-gift-eligible', eligible);
        let banner = document.querySelector('.zh-gift-banner');
        if (!eligible) {
          banner?.remove();
          if (this.dialog.open) this.dialog.close();
          return;
        }
        const footer = document.querySelector('#main-cart-footer .cart__blocks');
        if (!footer) return;
        if (!banner) {
          banner = document.createElement('aside');
          banner.className = 'zh-gift-banner';
          const title = document.createElement('strong');
          title.textContent = this.config.title;
          const summary = document.createElement('p');
          summary.dataset.giftSummary = '';
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.zhGiftOpen = '';
          button.textContent = this.config.choose;
          banner.append(title, summary, button);
          footer.prepend(banner);
        }
        const chosen = this.chosen();
        banner.querySelector('[data-gift-summary]').textContent = chosen.length ? this.config.saved + ' ' + chosen.join(' + ') : this.config.intro;
      }
      async clearGift() {
        if (!this.keys.some(key => this.cart.attributes?.[key])) return;
        this.cart = await this.request('cart/update.js', { attributes: Object.fromEntries(this.keys.map(key => [key, ''])) });
      }
      async checkout() {
        if (this.busy) return;
        this.busy = true;
        try {
          await this.refresh();
          if (this.eligible()) {
            this.open(true);
          } else {
            await this.clearGift();
            location.assign(this.root + 'checkout');
          }
        } catch {
          this.open(false);
          this.status.textContent = this.config.error;
        } finally {
          this.busy = false;
        }
      }
      open(checkout) {
        this.pendingCheckout = checkout;
        this.status.textContent = '';
        const chosen = this.chosen();
        this.selects.forEach((select, index) => { select.value = chosen[index] || ''; });
        this.updateOptions();
        if (!this.dialog.open) this.dialog.showModal();
        this.selects[0].focus();
      }
      updateOptions() {
        this.selects.forEach((select, index) => {
          [...select.options].forEach(option => { option.disabled = !!option.value && option.value === this.selects[1 - index].value; });
          select.setCustomValidity('');
        });
        this.querySelector('[data-gift-retinal]').hidden = !this.selects.some(select => /^Crystal Retinal (6|10)$/.test(select.value));
      }
      async save(event) {
        event.preventDefault();
        if (this.busy) return;
        const values = this.selects.map(select => select.value);
        if (values[0] === values[1] || values.some(value => !this.samples.includes(value))) {
          this.selects[1].setCustomValidity(this.config.invalid);
          this.selects[1].reportValidity();
          return;
        }
        this.busy = true;
        const button = this.querySelector('[type="submit"]');
        button.disabled = true;
        this.status.textContent = '';
        try {
          await this.refresh();
          if (!this.eligible()) {
            await this.clearGift();
            if (this.pendingCheckout) location.assign(this.root + 'checkout');
            return;
          }
          const attributes = { [this.keys[0]]: values[0], [this.keys[1]]: values[1], [this.keys[2]]: '1 van elk van de 3 Jane Iredale Holiday 2026 cadeausets: 2 verschillende Medik8 luxe minisamples cadeau' };
          this.cart = await this.request('cart/update.js', { attributes });
          if (!this.eligible()) {
            await this.clearGift();
            this.sync();
            return;
          }
          if (!this.chosen().length) throw new Error('Selections not saved');
          this.sync();
          this.dialog.close();
          if (this.pendingCheckout) location.assign(this.root + 'checkout');
        } catch {
          this.status.textContent = this.config.error;
        } finally {
          this.busy = false;
          button.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
